export default "__VITE_ASSET__DO1mZb0Z__"